import React, { useEffect, useState } from 'react';
import { useTour } from './TourProvider';

const TourHighlight = () => {
  const { isTourActive, currentStep, tourSteps } = useTour();
  const [highlightStyle, setHighlightStyle] = useState({});

  useEffect(() => {
    if (!isTourActive || !tourSteps[currentStep]) {
      setHighlightStyle({});
      return;
    }

    const step = tourSteps[currentStep];
    if (!step.selector) return;

    const updateHighlight = () => {
      const element = document.querySelector(step.selector);
      if (element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        setHighlightStyle({
          position: 'absolute',
          top: rect.top + scrollTop - 4,
          left: rect.left + scrollLeft - 4,
          width: rect.width + 8,
          height: rect.height + 8,
          border: '2px solid #2563eb',
          borderRadius: '8px',
          pointerEvents: 'none',
          zIndex: 9997,
          transition: 'all 0.3s ease-in-out',
          boxShadow: '0 0 0 4px rgba(37, 99, 235, 0.1)',
        });
      }
    };

    setTimeout(updateHighlight, 100);
    window.addEventListener('resize', updateHighlight);
    return () => window.removeEventListener('resize', updateHighlight);
  }, [isTourActive, currentStep, tourSteps]);

  if (!isTourActive || !highlightStyle.top) return null;

  return <div style={highlightStyle} />;
};

export default TourHighlight;